// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsDate_container__qCKFs"};